import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">{aboutContent.title}</h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">{aboutContent.intro}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
          {aboutContent.highlights.map((item) => (
            <div key={item.label} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/60">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{item.number}</div>
              <div className="text-xs md:text-sm text-foreground-600">{item.label}</div>
            </div>
          ))}
        </div>

        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto text-center">
          {aboutContent.detail}
        </p>
      </div>
    </section>
  );
}